<template>
  <div>
    <div class="ft-22-333">账户设置</div>
    <div class="se-flex se-p-t-20 se-p-b-20">
      <img
        src="../../../assets/icons/phone_w.png"
        style="width: 54px; height: 54px"
      />
      <div class="se-m-l-15">
        <div class="ft-16-333-b">手机绑定</div>
        <div class="se-flex aic">
          <div class="se-m-r-30 ft-14-666">
            {{ userInfo.encryptPhonenumber }}
          </div>
          <el-button type="text" style="color: #e44352" @click="isShow('phone')"
            >更换手机号</el-button
          >
        </div>
      </div>
    </div>
    <div class="se-flex se-p-t-20 se-p-b-20 se-bor-b se-bor-t">
      <img
        src="../../../assets/icons/suo_w.png"
        style="width: 54px; height: 54px"
      />
      <div class="se-m-l-15">
        <div class="ft-16-333-b">密码</div>
        <div class="se-flex aic">
          <div class="se-m-r-30 ft-14-666">********</div>
          <el-button
            type="text"
            style="color: #e44352"
            @click="isShow('password')"
            >重置</el-button
          >
        </div>
      </div>
    </div>
    <div class="se-flex se-p-t-20 se-p-b-20">
      <img
        src="../../../assets/icons/suo_w.png"
        style="width: 54px; height: 54px"
      />
      <div class="se-m-l-15">
        <div class="ft-16-333-b">企业微信绑定</div>
        <div class="se-flex aic">
          <div class="se-m-r-30 ft-14-666">绑定企业微信进行快速登录</div>
          <el-popover
            v-if="user.accountType === 0"
            placement="bottom"
            width="330"
            trigger="click"
          >
            <div id="wx" class="wx_code"></div>
            <el-button
              type="text"
              style="color: #e44352"
              slot="reference"
              @click="getWxCode"
              >去绑定</el-button
            >
          </el-popover>
          <p v-else class="ft-16-yellow" style="font-size: 14px">已绑定</p>
        </div>
      </div>
    </div>
    <!-- 修改信息对话框 -->
    <el-dialog
      :title="type === 'phone' ? '更换手机号' : '重置密码'"
      :visible.sync="visible"
      width="360px"
    >
      <put-msg :type="type" @changeOk="changeOk"></put-msg>
    </el-dialog>
  </div>
</template>

<script>
// import vueQr from "vue-qr";
import putMsg from "./putMsg.vue";

export default {
  components: {
    // vueQr,
    putMsg,
  },

  data() {
    return {
      user: this.$store.state.userInfo,
      showCode: false,
      userInfo: this.$store.state.userInfo,
      downloadData: {
        url: "扫码访问的链接地址",
      },
      visible: false,
      type: "",
    };
  },

  watch: {
    "$store.state.userInfo": {
      handler(value) {
        this.user = value;
        this.$forceUpdate();
      },
      deep: true,
    },
  },

  //server/portal/personCenter/getCaptcha/
  methods: {
    async getWxCode() {
      // /server/system/user/getOauth2Link
      this.showCode = true;
      const res = await this.$http.get(`server/system/user/getOauth2Link`, {
        redirectUrl: `${location.origin}${location.pathname}#/user/index?defaultActive=9`,
      });
      const wwLogin = new WwLogin({
        id: "wx",
        appid: res.data.cropId,
        agentid: res.data.agentId,
        redirect_uri: res.data.redirect,
      });
    },
    async changeOk() {
      this.visible = false;
      const user = await this.$http.get(
        "server/portal/personCenter/getUserDetails"
      );
      await this.$store.dispatch("setUserInfo", user.data);
      this.$forceUpdate();
    },
    isShow(value) {
      if (value === "phone" && this.userInfo.accountType === 1) {
        this.$message.info("企业微信用户不允许修改");
        return;
      }
      this.type = value;
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-popover .se-toast {
  position: absolute;
  top: 225px;
  right: 0;
}
</style>
